// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"a0f0cdc5","453":"1407b060","991":"92d506b0"}[chunkId] + ".chunk.js";
};